/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const RewindSmallIcon = ({ width = 15, height = 16, color = '#fff', children, ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 15 16' fill={color} {...props} xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.60339 0.354821C3.79865 0.550083 3.79865 0.866665 3.60339 1.06193L2.68611 1.97921H7.49984C11.1012 1.97921 14.0207 4.89868 14.0207 8.50004C14.0207 12.1014 11.1012 15.0209 7.49984 15.0209C3.89848 15.0209 0.979004 12.1014 0.979004 8.50004C0.979004 8.2239 1.20286 8.00004 1.479 8.00004C1.75515 8.00004 1.979 8.2239 1.979 8.50004C1.979 11.5491 4.45077 14.0209 7.49984 14.0209C10.5489 14.0209 13.0207 11.5491 13.0207 8.50004C13.0207 5.45097 10.5489 2.97921 7.49984 2.97921H2.68611L3.60339 3.89649C3.79865 4.09175 3.79865 4.40833 3.60339 4.60359C3.40813 4.79886 3.09155 4.79886 2.89628 4.60359L1.12545 2.83276C1.03168 2.73899 0.979004 2.61182 0.979004 2.47921C0.979004 2.3466 1.03168 2.21942 1.12545 2.12565L2.89628 0.354821C3.09155 0.159558 3.40813 0.159558 3.60339 0.354821Z'
    />
    <text x='48%' y='55%' fontSize={6} dominantBaseline='middle' textAnchor='middle'>
      {children}
    </text>
  </svg>
);

export default RewindSmallIcon;
